/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Overview_Plans_EnterpriseInputs */

const es_admin_company_overview_plans_enterprise = /** @type {(inputs: Admin_Company_Overview_Plans_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const en_admin_company_overview_plans_enterprise = /** @type {(inputs: Admin_Company_Overview_Plans_EnterpriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {Admin_Company_Overview_Plans_EnterpriseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_company_overview_plans_enterprise = /** @type {((inputs?: Admin_Company_Overview_Plans_EnterpriseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Overview_Plans_EnterpriseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_company_overview_plans_enterprise(inputs)
	return en_admin_company_overview_plans_enterprise(inputs)
});
export { admin_company_overview_plans_enterprise as "admin.company_overview.plans.enterprise" }